exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-c0cd8e2a] {\n    display: block;\n}\n.modal-body[data-v-c0cd8e2a] {\n    overflow: visible;\n}\n.modal-footer .btn[data-v-c0cd8e2a] {\n    margin-bottom: 0;\n}\n", ""]);

// exports
